import { useQuery } from '@tanstack/react-query';

import CustomerService from '@/services/CustomerService';

export const GET_CATEGORY_SEO_CSV_QUERY_KEY = ['get-category-seo-csv'];

export function useGetCategorySeoCSV() {
  const { data, isFetching, refetch } = useQuery({
    queryKey: GET_CATEGORY_SEO_CSV_QUERY_KEY,
    enabled: false,
    queryFn: () => CustomerService.getCategorySeoCSV(),
  });

  return {
    categorySeoCSV: data,
    isLoading: isFetching,
    getCategorySeoCSV: refetch,
  };
}
